import { getSplittedPath as n } from "./index532.mjs";
function f(r, o) {
  const t = n(r);
  if (t.length === 0 || typeof o != "object" || o === null)
    return;
  let e = o[t[0]];
  for (let i = 1; i < t.length && e !== void 0; i += 1)
    e = e[t[i]];
  return e;
}
export {
  f as getPath
};
